// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_2zkLD931LQwPJSYp-oN5Mr","body":"_2CLPwLmo5l11oDqrNaRUpV","close-button":"_3eqNAd26hWMoKMDWkStbc0","closeButton":"_3eqNAd26hWMoKMDWkStbc0"};